module.exports = __webpack_public_path__ + "img/soundcloud-icon.c7c4b383.svg";